
import React, { useEffect, useState } from 'react';
import CommonDialog from 'components_newui/dialogs/CommonDialog';
import CountrySelect from './CountrySelect';

export const ShowPopupCountrySelectFirstTime = (props) => {
  const {
    getCountriesList,
    userEmail,
    postAddCountryAcceptenceFn,
    loginUser,
    currentDomain,
    isCommunityAssigned
  } = props;

  const [dialogOpenCountry, setDialogOpenCountry] = useState(false);

  // OPEN POPUP ONLY WHEN NEEDED
  useEffect(() => {
    // show popup only when user is NOT community assigned
    if (isCommunityAssigned) {
      setDialogOpenCountry(true);
    }
  }, [isCommunityAssigned]);

  return (
    <CommonDialog
      open={dialogOpenCountry}
      title="To ensure you have the best experience on the Innovate platform, please confirm your market or Vodafone / Vodacom subsidiary below"
      confirmText="Submit"
      cancelText=""
      hideSubmitBtn     // form will have its own submit button
      content={
        <CountrySelect
          getCountriesList={getCountriesList}
          setDialogOpenCountry={setDialogOpenCountry}
          postAddCountryAcceptenceFn={postAddCountryAcceptenceFn}
          loginUser={loginUser}
          userEmail={userEmail}
          currentDomain={currentDomain}
          isCommunityAssigned={isCommunityAssigned}
        />
      }
    />
  );
};

